module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/50k-inactive-f33b6da105ae6d21540035ed2ce73fb7.png";